import { Box, Button, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { brandViewByAlcoholIdRequest } from "../../../redux/brands/BrandAction";
import { productQuantitySearchViewAllRequest } from "../../../redux/productQuantity/ProductQuantityAction";
import { productViewByBrandIdRequest } from "../../../redux/products/ProductAction";
import { alcoholSearchViewAllRequest } from "../../../redux/typeOfAlcohol/TypeOfAlcoholAction";
import {
  wholesalerProductAddRequest,
  wholesalerProductResetState,
} from "../../../redux/wholesalerProduct/WholesalerProductAction";
import { styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import ReusableFormFields from "../../constant/reusableFormFields";
import { mapBackendMessage } from "../../notification/BackendMessage";
import CommonDialog from "../../notification/Dialogbox";
import { APP_LINKS } from "../../global/wholeSalerMenuItems";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const AddProduct = () => {
  const {
    handleSubmit,
    setValue,
    control,
    register,
    reset,
    setError,
    formState: { errors },
    watch,
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const [name, setName] = useState("");
  const [filteredProductQuantities, setFilteredProductQuantities] = useState(
    []
  );
  const [brandMessage, setBrandMessage] = useState("");
  const [productMessage, setProductMessage] = useState("");

  const addWholesalerProductState = useSelector(
    (state) => state?.wholesalerProduct?.addWholesalerProduct || {}
  );

  const WholesalerId = useSelector(
    (state) => state?.values?.loginValues?.[0]?.wholesaler_id
  );

  const typeOfAlcoholState = useSelector(
    (state) => state?.TypeAlcohol?.viewAllSearchAlcohols || {}
  );
  const AlcoholList = typeOfAlcoholState?.data?.data || [];

  useEffect(() => {
    dispatch(alcoholSearchViewAllRequest());
  }, [dispatch]);

  const brandViewAllState = useSelector(
    (state) => state?.brand?.viewBrandsByAlcoholId
  );
  const brandList = brandViewAllState?.data?.data || [];
  const selectedAlcoholId = watch("type_of_alcohol_id");

  useEffect(() => {
    if (selectedAlcoholId) {
      dispatch(brandViewByAlcoholIdRequest(selectedAlcoholId));
    }
  }, [selectedAlcoholId, dispatch]);

  const productViewAllState = useSelector(
    (state) => state?.product?.viewProductsByBrandId || {}
  );
  const productList = productViewAllState?.data?.data || [];
  const selectedBrandId = watch("brand_id");

  useEffect(() => {
    if (selectedBrandId) {
      dispatch(productViewByBrandIdRequest(selectedBrandId));
    }
  }, [selectedBrandId, dispatch]);

  const viewAllProductQuantitiesState = useSelector(
    (state) => state?.productQuantity?.viewAllSearchProductQuantities || {}
  );
  const productQuantityList = viewAllProductQuantitiesState?.data?.data || [];

  useEffect(() => {
    dispatch(productQuantitySearchViewAllRequest());
  }, [dispatch]);

  const dynamicAlcoholOptions = AlcoholList?.map((TypeAlcohol) => ({
    value: TypeAlcohol?.id,
    label: TypeAlcohol?.alcohol_type,
  }));
  const dynamicBrandOptions = brandList?.map((brand) => ({
    value: brand?.id,
    label: brand?.brand_name,
  }));

  const dynamicProductOptions = productList?.map((product) => ({
    value: product?.id,
    label: product?.product_name,
  }));

  const selectedProductId = watch("product_id");

  const filterProductQuantities = () => {
    if (!selectedProductId || !WholesalerId) return;

    const filteredOptions = productQuantityList?.filter(
      (item) =>
        item?.product_id === selectedProductId &&
        item?.wholesaler_id === WholesalerId &&
        item?.status === 1
    );

    if (filteredOptions?.length === 0) {
      setFilteredProductQuantities([
        {
          value: "",
          label: (
            <span style={styles.capacityWarning}>
              ⚠ Quantity for the selected sub brand does not exist
            </span>
          ),
          isDisabled: true,
        },
      ]);
    } else {
      setFilteredProductQuantities(
        filteredOptions?.map((item) => ({
          value: item?.id,
          label: `${item?.type_of_quantity} ${item?.measurements || ""}`,
        }))
      );
    }
  };

  const handleCategoryChange = (event) => {
    const selectedProductId = event.target.value;
    setName(selectedProductId);
    setValue("product_id", selectedProductId);
    filterProductQuantities();
    setValue("type_of_quantity_id", "");
  };

  useEffect(() => {
    filterProductQuantities();
  }, [selectedProductId, WholesalerId]);

  const handleAlcoholChange = (event) => {
    const selectedAlcoholId = event.target.value;
    setValue("type_of_alcohol_id", selectedAlcoholId);

    // dispatch(brandViewByAlcoholIdRequest(selectedAlcoholId));

    setValue("brand_id", "");
    setValue("product_id", "");
    setValue("type_of_quantity_id", "");

    setBrandMessage("");
    setProductMessage("");
  };

  const handleBrandChange = (event) => {
    const selectedBrandId = event.target.value;
    setValue("brand_id", selectedBrandId);

    // dispatch(productViewByBrandIdRequest(selectedBrandId));

    setValue("product_id", "");
    setValue("type_of_quantity_id", "");

    setProductMessage("");
  };

  const filterBrands = () => {
    if (!selectedAlcoholId) return;

    if (dynamicBrandOptions.length === 0) {
      setBrandMessage("⚠ No brands available for the selected alcohol type.");
    } else {
      setBrandMessage("");
    }
  };

  const filterProducts = () => {
    if (!selectedBrandId) return;

    if (dynamicProductOptions.length === 0) {
      setProductMessage("⚠ No sub brand available for the selected brand.");
    } else {
      setProductMessage("");
    }
  };

  useEffect(() => {
    filterBrands();
    filterProducts();
  }, [dynamicBrandOptions, dynamicProductOptions]);

  const inputFields = [
    {
      name: "type_of_alcohol_id",
      label: "Type Of Alcohol",
      type: "searchable-select",
      options: dynamicAlcoholOptions,
      size: "selectMedium",
      rules: { required: "Type Of Alcohol is required" },
      onChange: handleAlcoholChange,
    },
    {
      name: "brand_id",
      label: "Brand Name",
      type: "searchable-select",
      size: "selectMedium",
      options: [
        ...dynamicBrandOptions,
        {
          value: "",
          label: brandMessage ? (
            <span style={styles.capacityWarning}>{brandMessage}</span>
          ) : (
            ""
          ),
          isDisabled: true,
        },
      ],
      rules: { required: "Brand Name is required" },
      onChange: handleBrandChange,
    },
    {
      name: "product_id",
      label: "Sub Brand Name",
      type: "searchable-select",
      size: "selectMedium",
      options: [
        ...dynamicProductOptions,
        {
          value: "",
          label: productMessage ? (
            <span style={styles.capacityWarning}>{productMessage}</span>
          ) : null,
          isDisabled: true,
        },
      ],
      rules: { required: "Sub Brand Name is required" },
      onChange: handleCategoryChange,
    },
    {
      name: "type_of_quantity_id",
      label: "Quantity",
      type: "searchable-select",
      size: "selectMedium",
      options: filteredProductQuantities,
      rules: { required: "Quantity is required" },
    },
    {
      name: "alcohol_percentage",
      label: "Alcohol Percentage",
      rules: { required: "Alcohol Percentage is required" },
    },
    { name: "price", label: "Price", rules: { required: "Price is required" } },
    {
      name: "quantity",
      label: "Stock",
      rules: { required: "Stock is required" },
    },
  ];

  const onSubmit = (data) => {
    const formData = {
      ...data,
      wholesaler_id: WholesalerId,
    };
    dispatch(wholesalerProductAddRequest(formData));
  };

  const handleAddWholesalerProductResponse = () => {
    if (addWholesalerProductState?.error) {
      const errorMessage = addWholesalerProductState?.errormessage;
      const errorFields = addWholesalerProductState?.errorFields || {};
      if (Object.keys(errorFields).length > 0) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
      } else if (typeof errorMessage === "string") {
        setError("product_id", {
          type: "manual",
          message: errorMessage,
        });
      } else {
        const customMessage = mapBackendMessage(
          addWholesalerProductState?.errormessage ||
            "An error occurred while updating details."
        );
        setDialogMessage(customMessage);
        setIsSuccess(false);
        setDialogOpen(true);
      }
    } else if (addWholesalerProductState?.success) {
      setDialogMessage("Product Added Successfully");
      setIsSuccess(true);
      setDialogOpen(true);
      reset();
      dispatch(wholesalerProductResetState());
    }
  };

  const handleCancel = () => {
    reset({
      product_id: "",
      brand_id: "",
      type_of_alcohol_id: "",
      type_of_quantity_id: "",
      type_of_quantity: "",
      alcohol_percentage: "",
      price: "",
      quantity: "",
    });

    setBrandMessage("");
    setProductMessage("");
    setFilteredProductQuantities([]);
    dispatch(wholesalerProductResetState());
  };

  useEffect(() => {
    handleAddWholesalerProductResponse();
  }, [addWholesalerProductState]);

  useEffect(() => {
    dispatch(wholesalerProductResetState());
  }, []);

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={6} lg={5} xl={5}>
            <Box>
              <Typography
                variant="h4"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1> Add a New Product </h1>
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
            <Box sx={styles.addBackButtonDisplay}>
              <Button
                variant="contained"
                sx={styles.addBackButtonColor}
                startIcon={<ArrowBackIcon />}
                onClick={() => {
                  dispatch(wholesalerProductResetState());
                  navigate(APP_LINKS.PRODUCTLIST);
                }}
              >
                Back
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              required={true}
              setValue={setValue}
            />
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Submit"
                    size="medium"
                    type="submit"
                    buttonStyle="StyledButton"
                    disabled={addWholesalerProductState?.inProgress}
                    loading={addWholesalerProductState?.inProgress}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomButton
                    text="Cancel"
                    variant="contained"
                    size="medium"
                    fullWidth
                    buttonStyle="style1"
                    onClick={handleCancel}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>

      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={() => setDialogOpen(false)}
        messageSuccess={dialogMessage}
        messageError={dialogMessage}
      />
    </Container>
  );
};

export default AddProduct;
